module.exports = __webpack_public_path__ + "static/img/dashboard-grey.0540f16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sidebar/dashboard-grey.svg
// module id = 614
// module chunks = 2